<script setup lang="ts">
interface INavIconProps {
	src: string;
	fallback?: string;
	provider?: string | null;
	width?: number;
	height?: number;
	alt?: string;
}

withDefaults(defineProps<INavIconProps>(), {
	provider: "kentico",
	width: 24,
	height: 24,
});
const mounted = ref(false);
const loaded = ref(false);
const error = ref(false);

onMounted(() => (mounted.value = true));
</script>

<template>
	<div class="relative overflow-hidden flex items-center justify-center" :style="`width: ${width}px; height: ${height}px`">
		<NuxtImg
			v-if="error"
			:src="
				provider
					? fallback
						? '/medialibraries/content.gmgamingsystems.com/Synapse' + fallback
						: '/medialibraries/content.gmgamingsystems.com/Synapse/icons/productnav/product-fallback.svg'
					: fallback
			"
			:provider="provider || undefined"
			alt=""
			:width="width"
			:height="height"
			:class="['absolute w-full h-full', loaded ? 'opacity-0' : 'opacity-100']"
		/>
		<NuxtImg
			v-show="!error"
			:key="src"
			:src="'/medialibraries/content.gmgamingsystems.com/Synapse' + src"
			provider="kentico"
			:alt="alt"
			:width="width"
			:height="height"
			@error="error = true"
			@load="loaded = true"
			class="absolute w-full h-full transition-opacity duration-200 ease-in-out"
			:class="[loaded ? 'opacity-100' : 'opacity-0']"
		/>
	</div>
</template>
